import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const DeclinedHelpIcon: FC<{ ended_at: string }> = ({ ended_at }) => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" className={classes.title}>
            Connection Declined{" "}
            {ended_at && `on ${new Date(ended_at).toLocaleDateString()}`}
          </Typography>
          <Typography variant="body1" className={classes.text}>
            This client has declined your connection request
            {ended_at && ` on ${new Date(ended_at).toLocaleDateString()}`}. If
            this was a mistake, ask the client to re-share their unique code
            with you.
          </Typography>
        </>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default DeclinedHelpIcon
